'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { forwardRef, useContext, useImperativeHandle } from 'react';
import DatePicker from 'react-datepicker';
import { FormContext } from '../index.js';
import Input from '../../Input/index.js';

var DatePickerInput = function (props) {
    var _a = props.value, value = _a === void 0 ? '' : _a, _b = props.onClick, onClick = _b === void 0 ? function () { } : _b, _c = props.onChange, onChange = _c === void 0 ? function (_e) { } : _c, _d = props.onClear, onClear = _d === void 0 ? function () { } : _d, _f = props.label, label = _f === void 0 ? '' : _f, _g = props.isRequired, isRequired = _g === void 0 ? false : _g, _h = props.hasError, hasError = _h === void 0 ? false : _h, _j = props.onFocus, onFocus = _j === void 0 ? function () { } : _j, _k = props.disabled, disabled = _k === void 0 ? false : _k;
    return (React__default.createElement("div", { onClick: onClick },
        React__default.createElement(Input, { type: 'text', value: value, onChange: function (value, e) {
                if (e) {
                    onChange(e);
                }
                else if (value === '') {
                    onClear();
                }
            }, label: label, disabled: disabled, isRequired: isRequired, hasError: hasError, onFocus: onFocus })));
};
function FMDatePickerComponents(props, ref) {
    var name = props.name, locale = props.locale, label = props.label, _a = props.pickerType, pickerType = _a === void 0 ? 'monthPicker' : _a, isRequired = props.isRequired, maxDate = props.maxDate, disabled = props.disabled;
    var _b = useContext(FormContext), values = _b.values, setValues = _b.setValues, errors = _b.errors, onAnyChange = _b.onAnyChange, touched = _b.touched, setTouched = _b.setTouched, hasSubmittedRef = _b.hasSubmittedRef, forceShowError = _b.forceShowError;
    var setDate = function (date) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[name] = date, _a)));
        onAnyChange(date, name);
    };
    var typeProps = pickerType === 'monthPicker'
        ? {
            showMonthYearPicker: true,
            dateFormat: 'MM/yyyy'
        }
        : {
            showYearPicker: true,
            dateFormat: 'yyyy'
        };
    var showError = !!errors[name] && ((touched[name] && hasSubmittedRef.current) || forceShowError);
    useImperativeHandle(ref, function () {
        return {
            setDate: setDate
        };
    }, [values]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(DatePicker, __assign({ selected: values[name], onChange: function (date) {
                if (date) {
                    setDate(new Date(date));
                }
                else {
                    setDate(null);
                }
            }, customInput: React__default.createElement(DatePickerInput, { onClear: function () { return setDate(null); }, label: label, isRequired: isRequired, hasError: showError, disabled: disabled }), showPopperArrow: false, disabled: disabled }, typeProps, { strictParsing: true, locale: locale, onFocus: function () {
                var _a;
                setTouched(__assign(__assign({}, touched), (_a = {}, _a[name] = true, _a)));
            }, maxDate: maxDate })),
        showError && React__default.createElement("div", { className: 'small text-danger mt-1' }, errors[name])));
}
var FMDatePicker = forwardRef(FMDatePickerComponents);

export { DatePickerInput, FMDatePicker as default };
//# sourceMappingURL=index.js.map
